// Glue between Formik 1.x render props and the form-system components.
//
// Most of the site's forms return errors from `validate` as an ARRAY of
// { field, message } (Formik treats a non-empty array as invalid); the newer
// ones return the usual { field: message } object. Everything here accepts
// both.

export const errorMap = errors => {
    if (Array.isArray(errors)) {
        const map = {}
        errors.forEach(e => {
            if (e && e.field && !map[e.field]) map[e.field] = e.message
        })
        return map
    }
    return errors || {}
}

// Errors appear after the first submit attempt and then track the values
// live. Not on blur: mousedown on the submit button blurs the last field, its
// message pushes the button down, and the click lands on nothing.
export const fieldError = (formik, name) => {
    const message = errorMap(formik.errors)[name]
    return message && formik.submitCount > 0 ? message : ""
}

// Spread onto TextInput / Textarea / Select:
//   <TextInput label="Email" {...bind(props, "email")} />
export const bind = (formik, name) => ({
    name,
    value: formik.values[name],
    onChange: formik.handleChange,
    onBlur: formik.handleBlur,
    error: fieldError(formik, name),
})

// For <ErrorSummary errors={summaryErrors(props)} submitCount={props.submitCount} />
// `ids` maps a field name to the id of the element to focus when it differs
// (e.g. a checkbox group's fieldset).
export const summaryErrors = (formik, ids = {}) =>
    Object.entries(errorMap(formik.errors)).map(([field, message]) => ({
        field: ids[field] || field,
        message,
    }))
